import { render } from "./view_promotion_form.vue?vue&type=template&id=c7a398b6&scoped=true"
import script from "./view_promotion_form.vue?vue&type=script&lang=js"
export * from "./view_promotion_form.vue?vue&type=script&lang=js"

import "./view_promotion_form.vue?vue&type=style&index=0&id=c7a398b6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7a398b6"]])

export default __exports__